// extracted by mini-css-extract-plugin
module.exports = {"root":"Button__root___1Z5Y8","active":"Button__active___5nM6P"};